<template>
  <div>
    <div class="title">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 24px;
  color: #515671;
  text-align: center;
  padding: 20px 0 30px;
}
</style>
